import axios from 'axios';

import { ASESORIAS } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

/* Asesorias */
export const buscarAsesorias = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/asesorias/listar`, body, config);

        await dispatch({
            type: ASESORIAS.BUSCAR,
            payload: res.data.asesorias
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const crearAsesoria = (asesoria) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }

    const body = JSON.stringify(asesoria);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/asesorias/crear`, body, config);

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const obtenerAsesoria = (id) => async dispatch => {
    if(id){
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        
        const body = {
            id
        };

        try{
            await dispatch(changeLoader(true));
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/asesorias/detalles`, body, config);
            await dispatch({
                type: ASESORIAS.DETALLES,
                payload: res.data.asesoria
            });
        } catch (error){
            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        } finally {
            await dispatch(changeLoader(false));
        }
    }else{
        dispatch({
            type: ASESORIAS.DETALLES,
            payload: null
        });
    }
}

export const informacionAsesoria = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/asesorias/informacion`, body, config);

        await dispatch({
            type: ASESORIAS.DETALLES,
            payload: res.data.asesoria
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const limpiarAsesoria = () => dispatch => {
    dispatch({  
        type: ASESORIAS.DETALLES,
        payload: null
    });
}

export const editarAsesoria = (asignar) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }

    const body = JSON.stringify(asignar);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/asesorias/editar`, body, config);

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const eliminarAsesoria = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/asesorias/eliminar`, body, config);

        await dispatch({
            type: ASESORIAS.ELIMINAR,
            payload: body
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const obtenerAsesor = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/asesorias/asesor`, {}, config);

        await dispatch({
            type: ASESORIAS.ASESOR,
            payload: { asesor: res.data.asesor, historial: res.data.historial }
        });
    } catch (error) {
        if (error?.response?.status === 404) {
            await dispatch({
                type: ASESORIAS.ASESOR,
                payload: { asesor: null, historial: null }
            });
        } else if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const filtrarAsesorias = (opcion) => dispatch => {
    dispatch({
        type: ASESORIAS.FILTROS,
        payload: opcion
    });
}

/* Archivos */
export const crearArchivo = (archivo) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/asesorias/crear_archivo`, archivo, config);

        await dispatch({
            type: ASESORIAS.ARCHIVOS.LISTAR,
            payload: res.data.archivos
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const editarArchivo = (archivo) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/asesorias/editar_archivo`, archivo, config);

        await dispatch({
            type: ASESORIAS.ARCHIVOS.LISTAR,
            payload: res.data.archivos
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const detallesArchivo = (archivo) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(archivo);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/asesorias/detalles_archivo`, body, config);

        dispatch({
            type: ASESORIAS.ARCHIVOS.DETALLES,
            payload: res.data.archivo
        });
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const limpiarArchivo = () => dispatch => {
    dispatch({
        type: ASESORIAS.ARCHIVOS.DETALLES,
        payload: null
    });
}

export const eliminarArchivo = (archivo) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(archivo);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/asesorias/eliminar_archivo`, body, config);

        await dispatch({
            type: ASESORIAS.ARCHIVOS.LISTAR,
            payload: res.data.archivos
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}